/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        'html, body': {
            backgroundColor: 'white',
            color: 'fullBlack',
            fontFamily: 'body'
        },
        body: {
            minHeight: '100vh',
            color: 'fullBlack'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh',
            maxWidth: '2520px',
            mx: 'auto'
        },
        '.sr-only': {
            position: 'absolute',
            left: '-10000px',
            top: 'auto',
            width: '1px',
            height: '1px',
            overflow: 'hidden'
        },
        // Toast styles
        '.chakra-toast:first-child > .chakra-toast__inner': {
            marginTop: ['72px', null, '60px']
        },
        a: {
            textDecoration: 'underline'
        },
        // Google autocomplete list
        '.googleplaces-list': {
            listStyleType: 'none'
        },
        '.googleplaces-option': {
            display: 'inline-block',
            color: 'darkGray',
            textStyle: 'touchFriendly',
            textAlign: 'left'
        },
        '.googleplaces-item-active': {
            backgroundColor: 'lightBlue'
        }
    }
}
